module.exports = __webpack_public_path__ + "static/media/03_profile_no_loops.3b82e6f8.png";